export default "__VITE_ASSET__CgZ$PCXv__"